import "./AppCurrencyInputV2.scss";

import IntlCurrencyInput from "react-intl-currency-input";
import React from "react";

const currencyConfig = {
  locale: "pt-BR",
  formats: {
    number: {
      BRL: {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  },
};

const AppCurrencyInputV2 = ({
  name,
  label = "Valor",
  placeholder = "0,00",

  value,
  onChange,

  errors = {},
  touched = false,

  disabled = false,
  readOnly = false,
  isRequired = false,

  leftIcon, // opcional (ex: R$ / FontAwesome)
  className = "",
}) => {
  const hasError = !!errors?.[name] && !!touched;

  return (
    <div className={`hallapp-currencyv2 ${className} ${disabled ? "is-disabled" : ""} ${hasError ? "is-error" : ""}`}>
      {label && (
        <div className="hallapp-currencyv2__label">
          <span>{label}</span>
          {isRequired && <span className="hallapp-currencyv2__required"> *(obrigatório)</span>}
        </div>
      )}

      <div className={`hallapp-currencyv2__wrap ${readOnly ? "is-readonly" : ""}`}>
        {leftIcon ? <div className="hallapp-currencyv2__iconLeft">{leftIcon}</div> : null}

        <IntlCurrencyInput
          currency="BRL"
          config={currencyConfig}
          className="hallapp-currencyv2__control"
          value={value}
          disabled={disabled}
          readOnly={readOnly}
          placeholder={placeholder}
          onChange={(event, rawValue, maskedValue) => onChange?.(event, rawValue, maskedValue)}
        />
      </div>

      <div className="hallapp-currencyv2__meta">
        {hasError ? <div className="hallapp-currencyv2__error">{errors?.[name]}</div> : <span />}
      </div>
    </div>
  );
};

export default AppCurrencyInputV2;
